import { useCallback, useState, useEffect } from 'react';
import { stockyApi } from '../components/misc/StockyApi';

export const useOnboarding = (user) => {
  const accessToken = user?.accessToken;
  const [hasExistingItems, setHasExistingItems] = useState(false);
  const [onboardingSafeMode, setOnboardingSafeMode] = useState(true);
  const [safeModeResolved, setSafeModeResolved] = useState(false);

  const refreshCatalogState = useCallback(
    async ({ ignoreStoredPreference = false } = {}) => {
      const storedPreference = sessionStorage.getItem('newAccount.onboardingSafeMode');
      const hasStoredPreference = storedPreference === 'true' || storedPreference === 'false';
      setSafeModeResolved(false);

      if (hasStoredPreference && !ignoreStoredPreference) {
        setOnboardingSafeMode(storedPreference === 'true');
      }

      if (!accessToken) {
        setHasExistingItems(false);
        setOnboardingSafeMode(true);
        setSafeModeResolved(true);
        return { hasExistingItems: false, onboardingSafeMode: true };
      }

      try {
        const response = await stockyApi.getItems({ accessToken }, { page: 1, pageSize: 1 });
        const payload = response?.data;
        const total =
          payload && typeof payload === 'object' && !Array.isArray(payload)
            ? Number(payload.total || 0)
            : Array.isArray(payload)
              ? payload.length
              : 0;
        const hasItems = total > 0;
        setHasExistingItems(hasItems);
        if (ignoreStoredPreference || !hasStoredPreference) {
          setOnboardingSafeMode(hasItems);
        }
        return { hasExistingItems: hasItems, onboardingSafeMode: hasItems };
      } catch (error) {
        console.error('Error resolving onboarding safe mode default:', error);
        // An unknown catalog state must never be treated as a first import: that
        // could replace local stock after a transient API failure.
        setHasExistingItems(true);
        if (ignoreStoredPreference || !hasStoredPreference) {
          setOnboardingSafeMode(true);
        }
        return { hasExistingItems: true, onboardingSafeMode: true };
      } finally {
        setSafeModeResolved(true);
      }
    },
    [accessToken],
  );

  useEffect(() => {
    refreshCatalogState();
  }, [refreshCatalogState]);

  return {
    hasExistingItems,
    onboardingSafeMode,
    setOnboardingSafeMode,
    safeModeResolved,
    refreshCatalogState,
  };
};
